<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">
          {{ "Cast Details" }}
        </div>
        <div class="section-subTitle my-2">
          {{ "List Of All Casts" }}
        </div>
      </div>
      <div>
        <b-button v-if="$can('create', 'Crews')" variant="default" to="add-cast-crew" class="btn-blue">{{
          $tc("add")
        }}</b-button>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:800="getCastDetailsList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown
            :text="filterButtonTitle"
            variant="dropdown-curve"
            class="ml-auto mr-3 filter-dropdown"
          >
            <b-dropdown-item
              v-for="(status, statusIndex) in statuses"
              :key="statusIndex"
              v-on:click="filterStatus(status)"
              >{{ status.status }}</b-dropdown-item
            >
          </b-dropdown>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th>
            <img
              v-if="this.columnName != 'cast_name'"
              @click="onSortValue('cast_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('cast_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('cast_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ "Cast Name" }}
          </th>
          <th class="">
            <span class="pr-3">Alt Cast Name</span>
          </th>
        </tr>
      </thead>
      <template v-if="Items && Items.length > 0">
        <tbody>
          <tr v-for="(item, key) in Items" :key="key">
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="item.cast_is_active === 'Y' ? 'active' : 'inactive'"
                />

                <span
                  v-if="$can('update', 'Crews')"
                  class="edit-pen ml-4 blue-icon"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                  @click="goToRoute('/master/edit-cast-crew', item)"
                ></span>
              </div>
            </td>
            <td class="d-flex align-items-center">
              <CastIcon
                :name="item.cast_name"
                :image_url="item.cast_image_url"
                :width="40"
                :height="40"
                :classes="''"
              />
              <p>{{ $tc(item.cast_name, 1) }}</p>
            </td>
            <td>{{ $tc(item.alt_cast_name, 1) }}</td>
            <td>{{ item.cast_image_url }}</td>
          </tr>
        </tbody>
      </template>

      <tbody v-if="Items.length == 0">
        <tr>
          <td colspan="3">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="Items.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CastIcon from "@/components/Partials/CastIcon.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
    CastIcon,
  },
  data() {
    return {
      filter_is_active: "Y",
      Items: [],
      perPage: 10,
      isEditable: false,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      filterButtonTitle: "Active",
      statuses: [
        { status: "Active", flag: "Y" },
        { status: "Inactive", flag: "N" },
        { status: "All", flag: null },
      ],
      gridView: false,
      listView: true,
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
    };
  },
  beforeMount() {
    this.getCastDetailsList();
    this.getviewingnumber();
  },
  methods: {
    filterStatus: function (status) {
      this.filterButtonTitle = status.status;
      this.filter_is_active = status.flag;
      this.getCastDetailsList();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getCastDetailsList();
      } else {
        this.currentPage = event;
        this.getCastDetailsList();
      }
    },
    goToRoute: function (path, item) {
      const { mcm_id } = item;
      this.$router.push({
        path: path,
        query: {
          mcm_id: mcm_id,
        },
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getCastDetailsList();
    },
    getCastDetailsList: function () {
      this.Items = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        orderBy: this.orderby,
        columnName: this.columnName,
        filter_is_active: this.filter_is_active,
      };
      MasterService.GetAllCastNCrewDetails(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Items = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              console.log("Error:", data.message);
              this.$toasted.show(data.message);
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CastNCrewComponents/GetCastNCrewMaster.vue